import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Modal from 'react-modal';
import axios from 'axios';

import { MsalProvider, useMsal } from '@azure/msal-react';

import store from './scripts/core/state/store';
import Routes from './scripts/routes/Routes';
import reportWebVitals from './reportWebVitals';
import { tokenRequest } from './scripts/core/constants/login/loginConfig';
import { msalInstance } from './scripts/core/constants/login/msalInstance';

import './i18n';

import './styles/main.scss';

const rootElement = document.getElementById('root') as HTMLElement;

const AppWrapper = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error?.requiresInteraction) {
          await instance.loginRedirect(tokenRequest);
          return;
        }

        // eslint-disable-next-line consistent-return
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [instance]);

  return <Routes />;
};

ReactDOM.render(
  <Provider store={store}>
    <MsalProvider instance={msalInstance}>
      <AppWrapper />
    </MsalProvider>
  </Provider>,
  rootElement
);

Modal.setAppElement(rootElement);

reportWebVitals();
